import { z } from "zod";

export const supplierValidator = z.object({
  name: z.string().min(2),
});
